// In your UploadScreen.tsx
import React, { useContext } from "react";
import { AppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";

const UploadScreen: React.FC = () => {
  const { setUploadedFile } = useContext(AppContext);
  const navigate = useNavigate();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      // Save the selected file into the global context.
      setUploadedFile(e.target.files[0]);
    }
  };

  return (
    <div>
      <h2>Upload Your File</h2>
      <input type="file" onChange={handleFileChange} />
      <button onClick={() => navigate("/options")}>Next</button>
    </div>
  );
};

export default UploadScreen;
